import styled from 'styled-components/macro'
import { commonModalStyle, commonModalContentStyle } from 'src/global/helpers'
import { settingStyles } from '../SettingsModal/Setting/styles'

// Built from the settings modal's own pieces: grey body, white setting cards, explainer strips
export const Modal = styled.div`
  ${commonModalStyle}
  z-index: 101; /* over its own backdrop at 100, which is over the settings modal it opened from */
  width: min(600px, calc(100vw - 16px));

  /* 16px shorter at both ends than the settings modal, so it visibly sits on top of it */
  max-height: calc(100vh - 58px - 32px - 32px);
  max-height: calc(100dvh - 58px - 32px - 32px);

  @media (max-width: 1024px) {
    top: 90px;
    max-height: calc(100vh - 122px);
    max-height: calc(100dvh - 122px);
  }
  background: ${props => props.theme.pageBackground};
  border: 1px solid ${props => props.theme.border};
  transition: opacity 0.25s ease-in-out;
  color: ${props => props.theme.normalText};
  box-shadow: 0 4px 42px ${props => props.theme.shadow};
  overflow: hidden;

  &.closed {
    pointer-events: none;
    opacity: 0;
  }
`

export const Header = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: ${props => props.theme.pageBackground};
  font-size: 18px;
`

export const ModalContent = styled.div`
  ${commonModalContentStyle}
  ${settingStyles}
  position: relative;
  padding: 16px 8px;
  /* A classic (mouse or Windows) scrollbar takes space inside the right padding; keep both sides equal */
  scrollbar-gutter: stable both-edges;

  @media (max-width: 768px) {
    padding: 8px;
  }

  .group-title {
    margin-top: 32px;
    font-size: 18px;
    font-weight: 500;
    text-align: center;
  }

  /* The tips are sentences, not setting names */
  .settings-group .setting-name {
    font-weight: 400;
  }

  .row-icon {
    width: 30px;
    height: 30px;
    border-radius: 100%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background: ${props => props.theme.blue}22;
    color: ${props => props.theme.accent};
    font-size: 14px;
  }

  .setting-body .input-row {
    position: relative;

    input {
      padding-right: 72px;
      font-size: 16px;

      &.invalid {
        border-color: ${props => props.theme.red};
      }
    }

    .counter {
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 14px;
      color: ${props => props.theme.mutedText};
      pointer-events: none;

      &.at-limit {
        color: ${props => props.theme.red};
      }
    }
  }

  .account-id {
    font-size: 14px;
    font-weight: 500;
    color: ${props => props.theme.mutedText};
    white-space: nowrap;

    svg {
      margin-right: 6px;
    }
  }
`

export const ModalFooter = styled.div`
  border-top: 1px solid ${props => props.theme.border};
  padding: 16px;
  background: ${props => props.theme.pageBackground};
  display: flex;
  justify-content: space-around;
  align-items: center;

  button {
    margin-top: 0;
  }
`
